import { TabsLayout, BasicLayout, SafeAreaLayout } from '@/layouts';
import NativeBar from '@/components/nativeBar.vue';
import { App } from 'vue';

export default function setupComponents(app: App) {
  app.component(BasicLayout.name!, BasicLayout);
  app.component(TabsLayout.name!, TabsLayout);
  app.component(SafeAreaLayout.name!, SafeAreaLayout);
  app.component(NativeBar.name!, NativeBar);
}
